module.exports = __webpack_public_path__ + "static/mapa_svitavy_small-ed153a50b0bbd590919e0c99c6ed35f9.jpg";